export default __webpack_public_path__ + "static/media/Girdle of the Deathstalker.c5eeb7bc.jpg";